module.exports = __webpack_public_path__ + "img/v1-login.6ff4c3ee.png";